import {ajaxJsonCall} from '@freckle/ajax'
import {type LangT, Languages} from '@frontrow/console/src/entities/helpers/languages'
import {type ParserT, Parser, string, record, array, nullable} from '@freckle/parser'
import {PATHS} from '@frontrow/console/src/entities/helpers/paths'

type LanguageT = {
  name: string
  language: LangT
  description: string
  abbreviation: string | undefined | null
}

const languageParser: ParserT<LanguageT> = record({
  name: string(),
  language: Languages.parseT(),
  description: string(),
  abbreviation: nullable(string())
})

type LanguagesResponse = {
  languages: Array<LanguageT>
}

const responseParser: ParserT<LanguagesResponse> = record({
  languages: array(languageParser)
})

/** @internal */
export const parseLanguages: (a: unknown) => Array<LanguageT> = o =>
  Parser.run(o, array(languageParser))

const parseResponse: (a: unknown) => LanguagesResponse = o => Parser.run(o, responseParser)

export async function fetchLanguages(): Promise<Array<LanguageT>> {
  const url = `${PATHS.textAssetsUrl}/languages?language=en`
  const response = await ajaxJsonCall({url, method: 'GET'})
  return parseResponse(response).languages
}
